export enum RecordRequestSource {
  WORKERS_COMP = "Worker's Comp",
  HOSPITAL = "Hospital",
  CLINIC = "Clinic",
  OTHER = "Other",
}

export const RECORD_REQUEST_SOURCE_PROMPT = `
The source of a medical record request, used to route it. Worker's Comp, Hospital, and Clinic are
provider note-requests fulfilled in-house; Other (e.g. a third-party records or copy-service company)
is routed to the external records workflow. Only set when the requester is clearly identifiable.
`;
